// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"702":"21e61787","977":"21e61787","1794":"21e61787","2321":"21e61787","9770":"5c45cdc7"}[chunkId] + ".chunk.css";
};